import { appAxios } from "app/tools/axios/axios";

type TryLoginParameters = {
  password: string;
  username: string;
};

type TryLoginResponse = {
  token: string;
};

export const tryLogin = async (username: string, password: string) => {
  return appAxios.post<TryLoginParameters, { data: TryLoginResponse }>(
    "login_check",
    { password, username },
  );
};
